import { Component, OnInit } from '@angular/core';
import { LoadingController, AlertController, IonicModule } from '@ionic/angular';
import {Validators, FormBuilder, FormGroup, FormControl, ReactiveFormsModule} from '@angular/forms';
import { UserDataProvider } from "../../providers/user-data/user-data";
import { RequestUser, Brewery, AddBreweryRequest, Country } from '../../models/models';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { AddBeerFormPage } from '../add-beer-form/add-beer-form';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AppEventService } from '../../app/app-events';
import { Location } from '@angular/common';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { AddBreweryHeaderComponent } from '../../components/add-brewery-header/add-brewery-header';
import { IonicSelectableComponent } from 'ionic-selectable'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { Router } from '@angular/router';

/**
 * Generated class for the AddBreweryFormPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
  interface CountryCodeData {
  code: string;
  // Add other potential properties if they exist in your JSON
}

interface JsonResponse {
  codes: CountryCodeData[];
  // Add any other top-level properties if necessary
} 

@Component({
  selector: 'page-add-brewery-form',
  templateUrl: 'add-brewery-form.html',
  styleUrls: ['./add-brewery-form.scss'],
  standalone: false,
  imports: [
    IonicModule,
//    NavBarComponent,
    AddBreweryHeaderComponent,
    ReactiveFormsModule,
    TranslateModule,
    IonicSelectableComponent,
    CommonModule,
    FormsModule
  ]
})
export class AddBreweryFormPage implements OnInit {
  public static PATH: string = 'addbrewery';

  public addBreweryForm: FormGroup;

  loading: any = null;
  noitemstext: String;

  public countries: Array<Country>;
  private validLeave: boolean = false;

  breweryNameError: string = null;
  countryError: string = null;
  cityError: string = null;

  constructor(public location: Location,
    private formBuilder: FormBuilder,
    private userData: UserDataProvider,
    private locationService: LocationServiceProvider,
    private events: AppEventService,
    private beerService: BeerServiceProvider,
    private bhutil: BhutilProvider,
    private router: Router,
    private loadingCtrl: LoadingController,
    private translateService: TranslateService,
    public http: HttpClient,
    public alertCtrl: AlertController) {

    this.addBreweryForm = this.formBuilder.group({
        breweryName: [bhutil.getStateParam(this.router, 'searchtext'), Validators.required],
        country: ['', Validators.required],
        city: ['', Validators.required]
    })
  }

  loadCountries() {
      // 1. Specify the expected response type using generics: <JsonResponse>
      this.http.get<JsonResponse>("assets/countries/countries.json").subscribe({
          
          // 2. The 'response' object is already the parsed JSON object (JsonResponse)
          next: (response) => {
              
              // 3. Access 'codes' directly, no need for response.json()
              const codes = response.codes; 
              
              this.countries = [];
              
              // Using a modern for...of loop for cleaner iteration
              for (const countryItem of codes) {
                  const code = countryItem.code;
                  
                  this.countries.push({
                      code: code,
                      // Translation service call remains the same
                      name: this.translateService.instant('COUNTRIES.' + code)
                  });
              }
              
              console.log('Countries loaded:', this.countries);
          },
          
          // 4. Handle errors clearly
          error: (err) => {
              console.error("Error fetching countries JSON:", err);
          }
      });
  }

  ngOnInit() {
    console.log('add-brewery-form - ngOnInit');

    // Load countries
    console.log('add-brewery-form - retrieving countries')
    this.loadCountries();

    this.translateService.instant('ADDBEER.COUNTRY_NOT_FOUND')
  }

  addBrewery() {
    console.log('add-brewery-form - adding brewery');

    this.presentLoading();

    this.userData.getUserID().then((userID) => {
      console.log("(add-brewery-form - user logged in:) " + userID);
      let user = new RequestUser(userID, this.locationService.latitude, this.locationService.longitude);

      let name = this.addBreweryForm.value.breweryName;
      let country = this.addBreweryForm.value.country.code;
      let city = this.addBreweryForm.value.city;

      let addBreweryRequest = new AddBreweryRequest(
        name,
        country,
        city,
        user.userid,
        user.latitude,
        user.longitude)

      console.log(addBreweryRequest)

      this.beerService.addBrewery(addBreweryRequest).subscribe(
        (resp:any) => {
          console.log("add-brewery-form - server responsed 200!")

          // Create a brewery created event
          let brewery: Brewery = {
            id: resp.id,
            name: name,
            country: country,
            city: city
          }
          this.events.publish("addbrewery:saving", brewery);

          this.dismissLoading();
          // Go back to previous page
          this.validLeave = true;
          this.location.back();

        }, err => { console.log("add-brewery-form - server returned", err.errorCode, "error with message:", err.errorText);
          this.dismissLoading();
          switch (err.errorCode) {
            case "BHFUNCERROR_DUPLICATE_ENTRY":
              let message = this.translateService.instant('ERROR.ADDBREWERY_BHFUNCERROR_DUPLICATE_ENTRY');
              this.breweryNameError = message;
              this.countryError = message;
              this.cityError = message;
              break;
            default:
              // also contains "BHFUNCERROR_TECHNICAL_ERROR" || "BHFUNCERROR_FUNCTIONAL_ERROR"
              let confirmProm = this.alertCtrl.create({
                header: this.translateService.instant('ERROR.ERROR'),
                message: this.translateService.instant('ERROR.DEFAULT'),
                buttons: [
                  {
                    text: this.translateService.instant('GENERAL.OK'),
                    handler: () => {
                      console.log('add-brewery-form - error notice - ok clicked');
                    }
                  }
                ]
              });
              confirmProm.then((confirm) => confirm.present());
              break;
          }
        });
      });
  }

  presentLoading() {
    if (this.loading == null) {
      this.loading = this.loadingCtrl.create({
        message: this.translateService.instant('GENERAL.PLEASE_WAIT')
      });

      this.loading.present();

      setTimeout(() => {
        this.dismissLoading();
      }, 5000);
    }
  }

  dismissLoading() {
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.validLeave) {
        resolve();
      } else {
        let confirmProm = this.alertCtrl.create({
          header: this.translateService.instant('OPENPAGE.YOU_HAVE_NOT_SAVED_YOUR_BEER_YET'),
          message: this.translateService.instant('OPENPAGE.ARE_YOU_SURE_YOU_WANT_TO_LEAVE'),
          buttons: [
            {
              text: this.translateService.instant('OPENPAGE.NO_NEVERMIND'),
              role: 'cancel',
              handler: () => {
                console.log('No clicked');
                reject();
              }
            },
            {
              text: this.translateService.instant('OPENPAGE.YES_PLEASE'),
              handler: () => {
                console.log('Yes clicked');
                resolve();
              }
            }
          ]
        });
        confirmProm.then((confirm) => confirm.present());
      }
    })
  }

  ionViewDidEnter() {
    this.validLeave = false;
  }

  onBreweryNameChange() {
    this.breweryNameError = null;
    this.countryError = null;
    this.cityError = null;
  }

}
